import { API_URLS } from "../../constants";
import apiClient from "../../utils/interceptor";

export const getShippingLinesByCompanyId = async (company_id) => {
  try {
    const response = await apiClient.get(
      `${API_URLS.SHIPPING_LINES.GET_SHIPPING_LINES_BY_COMPANY}/${company_id}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching shipping lines by yard ID:", error);
    throw error;
  }
};

export const createShippingLine = async (data) => {
  try {
    const response = await apiClient.post(
      API_URLS.SHIPPING_LINES.CREATE_SHIPPING_LINE,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error creating shipping line:", error);
    throw error;
  }
};

export const updateShippingLine = async (shippingLineData) => {
    try {
        const response = await apiClient.patch(
            API_URLS.SHIPPING_LINES.UPDATE_SHIPPING_LINE,
            shippingLineData
        );
        return response.data;
    } catch (error) {
        console.error("Error updating shipping line:", error);
        throw error;
    }
};

export const deleteShippingLine = async (shippingLineId) => {
    try {
        const response = await apiClient.delete(
            API_URLS.SHIPPING_LINES.DELETE_SHIPPING_LINE,
            {
                data: { shipping_line_id: shippingLineId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting shipping line:", error);
        throw error;
    }
};
